import './index.scss'
import logo from '../../assets/Logo.svg'
import bg from '../../assets/background2.png'
import chatLogo from '../../assets/intel-search.png'
import downloadGuide from '../../assets/download_guide.png'
import generateIcon from '../../assets/generateIcon.svg'
import React, { useContext, useEffect, useState } from 'react'
import { DownloadOutlined } from '@ant-design/icons'
import { useMsal } from '@azure/msal-react'
import { Button, Spin, Dropdown, MenuProps, Space } from 'antd'
import getToken from '../../addTokenInterceptor'
import { API_DOWNLOAD_GUIDE, API_STORE_WA_FILES } from '../../urls'
import { DataContext } from '../../DataContext'
import { getHeaders, getUploadHeaders } from '../../services/headerconstants'
import ToasterMessage from '../ToasterMessageComponent'
import { logout } from '../../utils/authUtils'
import NotificationBanner from '../NotificationBanner'
import { BlockBlobClient } from '@azure/storage-blob'
import logoutIcon from '../../assets/logoutIcon.svg'
import backArrowIcon from '../../assets/backArrow.svg'
import adminDashboardIcon from '../../assets/adminDashboardIcon.svg'
import { TelemetryLogger } from '../../services/telemetryLogger'
import { runtimeConfig } from '../../runtimeConfig'

interface IHeaderComponent {
  projectNames: string
  roleName: any
  setCurrentScreen: () => void
}

export interface IApiRequestDownloadAndPreviewLink {
  admin_offering_name: string
  template_type: string
}

export interface IApiResponseDownloadAndPreviewLink {
  template_type: string
  links: Array<{
    template_filename: string
    download_link: string
    preview_link: string
  }>
}

const HeaderTileWorkshop: React.FC<IHeaderComponent> = (props: IHeaderComponent) => {
  const { instance } = useMsal()
  const API_URL = runtimeConfig.VITE_KDD_API
  const { user_email, projectId, idToken, accessToken, user_name } = getToken()
  const [spinning, setSpinning] = useState(false)
  const [loading, setLoading] = useState(false)
  const [percent, setPercent] = useState(0)
  const [errorMessage, setErrorMessage] = useState<string>('')
  const commonOutputScreenURL =
    runtimeConfig.VITE_ASCEND_1_1_URL + `/?ascend_project_id=${projectId}`

  const showLoader = () => {
    setSpinning(true)
    let ptg = -10

    const interval = setInterval(() => {
      ptg += 5
      setPercent(ptg)

      if (ptg > 120) {
        clearInterval(interval)
        setSpinning(false)
        setPercent(0)
      }
    }, 200)
  }
  const {
    currentScreen,
    setCurrentScreen,
    setShowWorkshopAssistantCancel,
    createSnippetValue,
    uuidConst,
    setAddPagesCount,
  } = useContext(DataContext)
  const handleClick = () => {
    if (projectId !== null) {
      const commonPageUrl = new URL(runtimeConfig.VITE_ASCEND_1_1_URL)
      commonPageUrl.searchParams.append('ascend_project_id', projectId)

      window.location.href = commonPageUrl.toString()
    }
  }

  const handleChatClick = () => {
    if (currentScreen === 'prepare') {
      if (projectId !== null) {
        setShowWorkshopAssistantCancel(true)
      }
    } else {
      if (projectId !== null) {
        const searchAndChatUrl = new URL(runtimeConfig.VITE_ASCEND_CHAT_URL)
        searchAndChatUrl.searchParams.append('ascend_project_id', projectId)
        window.location.href = searchAndChatUrl.toString()
      }
    }
  }

  const handleGenAiClick = () => {
    window.location.href = commonOutputScreenURL
  }

  const handleEndSessionClick = async () => {
    const waFiles: any = {}
    let slides = 0
    showLoader()
    createSnippetValue.forEach((element: any) => {
      const waFileList =
        waFiles[element?.RecommendedTopic] && waFiles[element?.RecommendedTopic].length > 0
          ? waFiles[element?.RecommendedTopic]
          : []
      if (element?.RecommendedTopic !== element?.name) {
        const imageInfo = []
        if (element?.fileName !== '' && element?.imagePosition !== '') {
          const imageDetails = {
            upload_type: 'image_file',
            source: element?.fileName,
            image_position: element?.imagePosition,
          }
          imageInfo.push(imageDetails)
        } else {
          const imageDetails = {
            upload_type: '',
            source: '',
            image_position: '',
          }
          imageInfo.push(imageDetails)
        }
        if (element?.text.includes('|')) {
          const firstPipeIndex = element?.text.indexOf('|')
          const lastPipeIndex = element?.text.lastIndexOf('|')
          const tableText = element?.text.substring(firstPipeIndex, lastPipeIndex + 1)
          const tabledataObj = {
            tabledata: [tableText],
          }
          waFileList.push({
            table: [tabledataObj],
            text: [],
            image_details: imageInfo,
          })
        } else {
          const textList = [element?.text]
          waFileList.push({
            text: textList,
            table: [],
            image_details: imageInfo,
          })
        }
        slides++
      }
      waFiles[element?.RecommendedTopic] = waFileList
    })
    setAddPagesCount(slides)
    try {
      const data = {
        uuid: uuidConst,
        projectid: projectId,
        createdby: user_name,
        wa_file: waFiles,
      }
      const response = await fetch(`${API_URL}/${API_STORE_WA_FILES}`, {
        method: 'POST',
        headers: getUploadHeaders(accessToken, idToken, projectId),
        body: JSON.stringify(data),
      })

      TelemetryLogger.instance.logRestApiCall(
        response,
        `${API_URL}/${API_STORE_WA_FILES}`,
        data,
      );


      if (!response?.ok) {
        const message = `An error has occurred: ${response.statusText}`
        throw new Error(message)
      } else {
        setCurrentScreen('fileUpload')
      }
    } catch (err) {
      if (err instanceof Error) {
        setErrorMessage(err.message)
      }
    }
    setCurrentScreen('fileUpload')
  }

  const [userEmail, setUserEmail] = useState('')
  const getUserEmail = async () => {
    setUserEmail(user_email)
  }

  const extractInitials = (fullName: string) => {
    const names = fullName.split(',')
    const firstName = names?.[1]?.trim()
    const lastName = names?.[0]?.trim()
    const firstNameInitial = firstName?.charAt(0)?.toUpperCase()
    const lastNameInitial = lastName?.charAt(0)?.toUpperCase()
    if (lastNameInitial && firstNameInitial) return `${lastNameInitial}${firstNameInitial}`
    if (lastNameInitial) return `${lastNameInitial}`
    if (firstNameInitial) return `${firstNameInitial}`
    return ''
  }

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <div className='email-badge'>
          <div className='button-align'>{extractInitials(user_name)}</div>
          <div>
            <div className='username'>{user_name}</div>
            <div className='email-content'>{userEmail}</div>
          </div>
        </div>
      ),
    },
    {
      key: '2',
      label: (
        <div className='sign-out' onClick={() => logout(instance)}>
          <img src={logoutIcon} alt='logout' />
          Log Out
        </div>
      ),
    },
  ]

  const contentStyle: React.CSSProperties = {
    backgroundColor: '#2e3238',
    color: '#d1d3d6',
    borderRadius: '4px',
  }

  const menuStyle: React.CSSProperties = {
    backgroundColor: '#41464E',
    color: '#d1d3d6',
    padding: '12px',
  }

  const getDownloadAndPreviewLink = async (
    payload: IApiRequestDownloadAndPreviewLink,
  ): Promise<IApiResponseDownloadAndPreviewLink> => {
    const queryParams = new URLSearchParams({
      admin_offering_name: payload.admin_offering_name,
      template_type: payload.template_type,
    })

    const downloadService = new URL(runtimeConfig.VITE_USER_GUIDE_URL)
    console.log('downloadService', downloadService)
    const url = `${downloadService}${API_DOWNLOAD_GUIDE}?${queryParams.toString()}`

    try {
      const response = await fetch(url, { headers: getHeaders(accessToken, idToken, projectId) })
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      const data = await response.json()
      return data // Assuming the response contains a 'links' array
    } catch (error) {
      console.error('Error fetching download and preview link:', error)
      throw error
    }
  }

  const downloadFiles = async (files: IApiResponseDownloadAndPreviewLink) => {
    for (const linkObject of files.links) {
      const downloadHref = linkObject.download_link
      const downloadName = linkObject.template_filename
      const blockBlobClient = new BlockBlobClient(downloadHref)

      try {
        const downloadResponse = await blockBlobClient.download()
        const blob = await downloadResponse.blobBody
        if (blob) {
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = downloadName
          a.click()
        }
      } catch (error) {
        console.error('Error downloading file:', error)
      }
    }
  }

  const fetchDataAndDownload = async () => {
    try {
      setLoading(true)
      const links = await getDownloadAndPreviewLink({
        admin_offering_name: 'Common-Userguide',
        template_type: 'userguide',
      })
      await downloadFiles(links)
    } catch (error) {
      console.error('Error in fetching and downloading files:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getUserEmail()
  })

  return (
    <>
      <div style={{ width: '100%', zIndex: '999' }}>

        {/*NOTE: Header component starts*/}
        <div className='header'>
          <div className='header-left'>
            <img src={logo} alt='deloitte logo' className='header-logo' />
            <div className='vertical-line' />
            <Button type='text' className='header-button' onClick={() => handleGenAiClick()}>
              <span className='header-text'>
                Gen AI<sup>TM</sup>
              </span>
            </Button>
          </div>
          <div className='header-right'>
            <div className='float-right'>
              <a className='dashboard-button content download-user-guide disable-pointer'>
                <img className='dashboard-icon' src={adminDashboardIcon} />
                <span>Admin Panel</span>
              </a>
              <div className='email-text'>
                <a onClick={fetchDataAndDownload} className='content download-user-guide'>
                  <img src={downloadGuide} />{' '}
                  {loading ? 'Downloading Guide...' : 'Download User Guide'}
                </a>
              </div>
              <div>
                <Dropdown
                  menu={{ items }}
                  placement='bottomRight'
                  dropdownRender={(menu) => (
                    <div style={contentStyle}>
                      {React.cloneElement(
                        menu as React.ReactElement<{
                          style: React.CSSProperties
                        }>,
                        { style: menuStyle },
                      )}
                    </div>
                  )}
                >
                  <div className='button-align'>{extractInitials(user_name)}</div>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
        {/*NOTE: Header component ends*/}

        <NotificationBanner />

        <div className='parent'>
          <img src={bg} className='image1' />
          {currentScreen === 'prepare' && (
            <div className='generate-ppt-button done-button' onClick={handleEndSessionClick}>
              {currentScreen !== 'prepare' && (
                <img src={generateIcon} alt='' className='chat-icon generate-icon' />
              )}
              Done
            </div>
          )}
          <div
            className={currentScreen === 'prepare' ? 'cancel-button' : 'chat-button'}
            onClick={handleChatClick}
          >
            {currentScreen !== 'prepare' && <img src={chatLogo} alt='' className='chat-icon' />}
            {currentScreen === 'prepare' ? 'Cancel' : 'Intelligent Search'}
          </div>
          <span className='back-arrow' onClick={handleClick}>
            <img src={backArrowIcon} alt='back-arrow' />
          </span>
          <span className='seperator'>|</span>
          <span className='workshop-heading'>{props.projectNames}</span>
        </div>
        <Spin spinning={spinning} percent={percent} fullscreen />
      </div>
      <ToasterMessage errorMessage={errorMessage} count={0} />
    </>
  )
}

export default HeaderTileWorkshop
